import { Form } from 'factorial-form'

class ExtraInformationForm extends Form {
  constructor(values: Record<string, boolean | string | number | 'date'> = {}) {
    super(values, {
      employee_id: 'number',
      no_resident_end_date: 'date',
      city: 'string',
      country: 'string',
      identifier: 'string',
      postal_code: 'string',
      state: 'string',
      address_line_1: 'string',
      address_line_2: 'string',
    })
  }
}

export default ExtraInformationForm
